const KEY = "rts_streak";

export const STREAK_VERSES = [
  { type: "verse", reference: "Lamentations 3:22-23", text: "Because of the Lord's great love we are not consumed, for his compassions never fail. They are new every morning; great is your faithfulness." },
  { type: "verse", reference: "Galatians 6:9", text: "Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up." },
  { type: "verse", reference: "Isaiah 40:31", text: "But those who hope in the Lord will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint." },
  { type: "verse", reference: "2 Timothy 4:7", text: "I have fought the good fight, I have finished the race, I have kept the faith." },
];

const dayKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

// Records today's visit; returns { count, reward } where reward is a verse on every 7th day.
export function recordVisit(now = new Date()) {
  const s = read();
  const today = dayKey(now);
  const y = new Date(now);
  y.setDate(y.getDate() - 1);
  let count = s.count || 0;
  if (s.last !== today) count = s.last === dayKey(y) ? count + 1 : 1;
  let reward = null;
  if (count > 0 && count % 7 === 0 && s.rewarded !== today) {
    reward = { ...STREAK_VERSES[(count / 7 - 1) % STREAK_VERSES.length], streak: count };
  }
  const days = Array.from(new Set([...(s.days || []), today])).sort().slice(-90);
  localStorage.setItem(KEY, JSON.stringify({ last: today, count, rewarded: reward ? today : s.rewarded, days }));
  return { count, reward, days };
}

export { dayKey };
